import { createContext, useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { getAppMode, getDefaultRoute, APP_MODES } from "config/appMode";

const AppModeContext = createContext(null);

export const AppModeProvider = ({ children }) => {
  const user = useSelector((state) => state.auth.user);
  const userDetails = user?.userDetails;
  const roleName = userDetails?.role;
  // Trigger memo recomputation when any of the inputs to mode resolution change.
  const effectiveAppMode = userDetails?.effectiveAppMode;
  const isVendorOrg = userDetails?.isVendorOrganization === true;

  const value = useMemo(() => {
    const mode = getAppMode(userDetails);
    return {
      mode,
      isAfms: mode === APP_MODES.AFMS,
      isFlex2: mode === APP_MODES.FLEX2,
      defaultRoute: getDefaultRoute(userDetails),
      roleName,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roleName, isVendorOrg, effectiveAppMode]);

  return (
    <AppModeContext.Provider value={value}>
      {children}
    </AppModeContext.Provider>
  );
};

export const useAppMode = () => {
  const context = useContext(AppModeContext);
  if (!context) {
    return {
      mode: APP_MODES.FLEX2,
      isAfms: false,
      isFlex2: true,
      defaultRoute: getDefaultRoute(null),
      roleName: null,
    };
  }
  return context;
};

export default AppModeContext;
